import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import {Router} from '@angular/router';
import {AppComponent} from './app.component';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

import {EntityService} from './entity.service';

@Component({
    selector: 'entity',
    templateUrl: './templates/entity.component.html',
    styleUrls: ['./styles/entity.component.css'],
    providers: [EntityService]
})
export class EntityComponent implements OnInit {
    currentUrl: string = "";
    component: string = "";

    //    for each component
    title_right_cs = '';
    title_left_cs = '';
    title_right_mc = 'CREATION';
    title_left_mc = 'LISTE';
    //    fin for each component

    showForm: boolean = true;

    entity_form: FormGroup;

    payment_methods: Array<any> = [];
    countries: Array<any> = [];
    countriesCtrl: FormControl;
    filteredCountries: Observable<any[]>;

    //    models
    id_entity: any;
    id_entity_information: any;
    reference: any;
    name: any;
    code: any;
    address: any;
    city: any;
    country: any;
    interlocuteur: any;
    phone: any;
    portable: any = '';
    mail: any;
    siteweb: any = '';
    nif: any = '';
    stat: any = '';
    rcs: any = '';
    //    fin models

    //    error
    country_undefined_error: boolean = false;
    //    fin error

    entity: any;
    list_entities: Array<any> = [];

    //    popup
    showconfirmation: boolean = false;
    message_confirm: string = '';

    //Search
    entity_name: string;
    entity_ref: string;
    entity_town: string;

    constructor(
        private app_component: AppComponent,
        private fb: FormBuilder,
        private entity_service: EntityService,
        private router: Router
    ) {
        this.currentUrl = this.router.url;
        this.CheckTheRoute();
        this.GetCountries();
        this.countriesCtrl = new FormControl('', Validators.required);
        this.filteredCountries = this.countriesCtrl.valueChanges
            .startWith(null)
            .map(state => state ? this.filterCountries(state) : this.countries.slice());
         
        this.app_component.valTest = '/suppliers';
        this.app_component.GetParent();
    }

    ngOnInit() {
        this.GetAllEntities();
        this.GetPaymentMethods();
        this.createForm();
    }

    CheckTheRoute() {
        if (this.currentUrl == '/clients') {
            this.component = 'CLIENT';
            this.title_right_cs = 'CLIENT';
            this.title_left_cs = 'CLIENTS';
        } else if (this.currentUrl == '/suppliers') {
            this.component = 'SUPPLIER';
            this.title_right_cs = 'FOURNISSEUR';
            this.title_left_cs = 'FOURNISSEURS';
        }
    }

    createForm() {
        this.entity_form = this.fb.group({
            reference_ctl: ['', Validators.required],
            name_ctl: ['', Validators.required],
            code_ctl: ['', Validators.required],
            address_ctl: ['', Validators.required],
            city_ctl: ['', Validators.required],
            country_ctl: this.countriesCtrl,
            interloculeur_ctl: ['', Validators.required],
            phone_ctl: ['', Validators.required],
            portable_ctl: [''],
            mail_ctl: ['', Validators.required],
            siteweb_ctl: [''],
            nif_ctl: ['', Validators.required],
            stat_ctl: ['', Validators.required],
            rcs_ctl: [''],
        });
    }

    filterCountries(name: string) {
        return this.countries.filter(state =>
            state.name_fr_fr.toLowerCase().indexOf(name.toLowerCase()) === 0);
    }

    GetCountries() {
        this.entity_service.GetCountriesList().then(response => {
            this.countries = response['countries'];
            console.log(this.countries);
        });
    }

    GetPaymentMethods() {
        this.entity_service.GetPaymentMethods().then(response => {
            this.payment_methods = response['methods'];
        });
    }

    ValidateButton() {
        if (this.entity_form.status === "VALID") {
            this.entity_service.InsertEntity(
                this.reference, this.name, this.code, this.address, this.city, this.country, this.component,
                this.interlocuteur, this.phone, this.portable, this.mail, this.siteweb, this.nif, this.stat, this.rcs,
                this.GetPaymentMethodsChecked()
            )
                .then(response => {
                    this.list_entities = response['entities'];
                });
            this.title_right_mc = 'CREATION';
            this.ResetForm();
        }
    }

    ValidateEditionButton() {
        if (this.entity_form.status === "VALID") {
            this.entity_service.UpdateEntity(
                this.id_entity, this.id_entity_information,
                this.reference, this.name, this.code, this.address, this.city, this.country, this.component,
                this.interlocuteur, this.phone, this.portable, this.mail, this.siteweb, this.nif, this.stat, this.rcs,
                this.GetPaymentMethodsChecked()
            )
                .then(response => {
                    this.list_entities = response['entities'];
                });
            this.title_right_mc = 'CREATION';
            this.ResetForm();
        }
    }

    GetPaymentMethodsChecked() {
        var response: string = "";
        for (var i = 0; i < this.payment_methods.length; i++) {
            if (this.payment_methods[i]['checked'] === true) {
                response = response.concat(this.payment_methods[i]['id_payment_method'], '_');
            }
        }
        return response;
    }

    IsCountryExist() {
        this.country_undefined_error = false;
        let value = this.country;
        var indice = 0;
        for (let item of this.countries) {
            if (item.name_fr_fr === value) {
                indice++;
            }
        }
        if (indice == 0) {
            this.country_undefined_error = true;
        }
    }

    GetAllEntities(): void {
        this.entity_service.GetAllEntities(this.component).then(response => {
            this.list_entities = response['entities'];
        });
    }

    SearchEntity(): void {
        if (this.entity_name === "") {
            this.entity_name = undefined;
        }
        if (this.entity_ref === "") {
            this.entity_ref = undefined;
        }
        if (this.entity_town === "") {
            this.entity_town = undefined;
        }
        this.entity_service.SearchEntity(this.component, this.entity_name, this.entity_ref, this.entity_town).then(response => {
            this.list_entities = response['entities'];
        });
    }

    ModifyEntity(entity: any): void {
        this.entity = entity;
        this.GetEntityDetails();
        this.title_right_mc = 'MODIFICATION';
    }

    DialogConfirm(entity: any): void {
        this.entity = entity;
        this.message_confirm = 'Voulez-vous vraiment supprimer ce client ?';
        if (this.component === 'SUPPLIER') {
            this.message_confirm = 'Voulez-vous vraiment supprimer ce fournisseur ?';
        }
        this.showconfirmation = true;
        this.app_component.hide_wrapper(this.showconfirmation);
    }

    GetEntityDetails(): void {
        this.entity_service.GetEntityDetails(this.entity.id_entity).then(response => {
            let entity_details = response['entity_details'];
            this.id_entity = entity_details.id_entity;
            this.id_entity_information = entity_details.id_entity_information;
            this.reference = entity_details.reference;
            this.name = entity_details.name;
            this.code = entity_details.code;
            this.address = entity_details.address;
            this.city = entity_details.city;
            this.country = entity_details.name_fr_fr;
            this.interlocuteur = entity_details.interlocutor;
            this.phone = entity_details.telephone;
            this.portable = entity_details.portable;
            this.mail = entity_details.mail;
            this.siteweb = entity_details.siteweb;
            this.nif = entity_details.nif;
            this.stat = entity_details.stat;
            this.rcs = entity_details.rcs;
            this.payment_methods = response['payment_methods'];
        });
    }

    DialogOk(): void {
        this.entity_service.DeleteEntity(this.entity).then(response => {
            this.list_entities = response['entities'];
            this.DialogCancel();
        });
    }

    DialogCancel(): void {
        this.showconfirmation = false;
        this.app_component.hide_wrapper(this.showconfirmation);
    }

    ResetForm(): void {
        this.entity_form.reset();
        this.showForm = false;
        this.GetPaymentMethods();
        setTimeout(() => {
            this.createForm();
            this.showForm = true;
            this.title_right_mc = 'CREATION';
            this.id_entity = undefined;
            this.id_entity_information = undefined;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/entity.component.ts